<template>
  <label class="app-input">
    <div class="app-input__inner-wrapper inner-wrapper">
      <input
        v-model="inputValue"
        class="inner-wrapper__input"
        type="text"
        :class="{ 'is-filled': inputValue || alwaysShowPlaceholder }"
      />
      <span
        class="inner-wrapper__text-placeholder"
        :class="{ 'is-required': required }"
      >
        {{ placeholder }}
      </span>
    </div>
    <span v-if="error" class="app-input__error-text">
      {{ error }}
    </span>
  </label>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'

export default defineComponent({
  name: 'AppInput',
  inheritAttrs: false,
  props: {
    modelValue: null,
    placeholder: {
      type: String,
      default: '',
    },
    required: Boolean,
    alwaysShowPlaceholder: Boolean,
    error: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { emit }) {
    const inputValue = computed({
      get() {
        return props.modelValue
      },
      set(val) {
        emit('update:modelValue', val)
      },
    })

    return { inputValue }
  },
})
</script>

<style lang="scss" scoped src="./Index.scss" />
